module.exports = __webpack_public_path__ + "media/images/extension-onboarding/arrow-right-down-72834e7e76bb8ddaff8cbfbed2cbfee1.png";